/**
 * Customer-data columns are campaign-specific columns whose field names are
 * namespaced with a shared prefix so they can be distinguished from standard
 * fields wherever the two are mixed together (column selectors, dataset record
 * editors, CSV exports, etc.).
 */
export const CUSTOMER_DATA_PREFIX = '_customer_data_';

/** Whether a field name refers to a customer-data column. */
export const isCustomerField = (field: string | null | undefined): boolean =>
  !!field && field.startsWith(CUSTOMER_DATA_PREFIX);

/** Extract the customer-data column key from a prefixed field name. */
export const getCustomerKey = (field: string): string =>
  field.slice(CUSTOMER_DATA_PREFIX.length);

/** Build the prefixed field name for a customer-data column key. */
export const getCustomerField = (key: string): string =>
  `${CUSTOMER_DATA_PREFIX}${key}`;
